import {
  TOKEN_KEY,
  SESSION_KEY,
  USER_ID_KEY,
  USER_NAME_KEY,
  USER_AVATAR_KEY,
} from '@/config/app.config'
import { safeLocalStorage } from '@/utils/ssr'

export const getToken = (): string => safeLocalStorage.getItem(TOKEN_KEY) || ''
export const setToken = (v: string) => safeLocalStorage.setItem(TOKEN_KEY, v)
export const removeToken = () => safeLocalStorage.removeItem(TOKEN_KEY)

export const getSessionId = (): string => safeLocalStorage.getItem(SESSION_KEY) || ''
export const setSessionId = (v: string) => safeLocalStorage.setItem(SESSION_KEY, v)

export const getUserId = (): string => safeLocalStorage.getItem(USER_ID_KEY) || ''
export const setUserId = (v: string) => safeLocalStorage.setItem(USER_ID_KEY, v)

export const getUserName = (): string => safeLocalStorage.getItem(USER_NAME_KEY) || ''
export const setUserName = (v: string) => safeLocalStorage.setItem(USER_NAME_KEY, v)

export const getAvatar = (): string => safeLocalStorage.getItem(USER_AVATAR_KEY) || ''
export const setAvatar = (v: string) => safeLocalStorage.setItem(USER_AVATAR_KEY, v)

export const clearAuth = () => {
  safeLocalStorage.removeItem(TOKEN_KEY)
  safeLocalStorage.removeItem(SESSION_KEY)
  safeLocalStorage.removeItem(USER_ID_KEY)
  safeLocalStorage.removeItem(USER_NAME_KEY)
  safeLocalStorage.removeItem(USER_AVATAR_KEY)
}
